import { menuGroup, menuItem } from "modules/helpers";

// components
import DataList from "./DataList.doc";
import DataListItem from "./DataListItem.doc";
import Loadable from "./Loadable.doc";

const components = [
  menuItem("<DataList/>", "data-list", DataList),
  menuItem("<DataList.Item/>", "data-list-item", DataListItem),
  menuItem("<Loadable/>", "loadable", Loadable),
];

export default [menuGroup("Components", "components", components)];
